import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { axiosServiceNowApi } from 'services/Api'
import { IExportReportBody, IReportBody } from 'types/report'

const ReportService = {
    notificationCountGroupingByAny:async (monthType: boolean, body: IReportBody) => {
        
        if (monthType) {
            return axiosServiceNowApi?.post(ROUTES_NAMES.report.post.notification_count_grouping_by_date, body)
        }
        return axiosServiceNowApi?.post(ROUTES_NAMES.report.post.notification_count_grouping_by_any, body)
    },
    autoNotification:async (body: IReportBody) => {
        return axiosServiceNowApi?.post(ROUTES_NAMES.report.post.auto_notification, body)
    },
    avgDate: async (body: IReportBody) => {
        return axiosServiceNowApi?.post(ROUTES_NAMES.report.post.avg_date, body)
    },
    downloadExcel:async (body: IExportReportBody) => {
        return axiosServiceNowApi?.post(ROUTES_NAMES.report.post.download_excel, body)
    },
}

export default ReportService